import { render, staticRenderFns } from "./surveyTemplate.vue?vue&type=template&id=42636f4a"
import script from "./surveyTemplate.vue?vue&type=script&lang=js"
export * from "./surveyTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports